var Highcharts = require('highcharts');
var Highcharts_Data = require('highcharts-data');


var chart_de = document.querySelector('.chart-de');
if (chart_de) {

  Highcharts.setOptions({
    lang: {
      decimalPoint: ',',
      thousandsSep: '.'
    }
  });

  Highcharts.chart('chart1-de', {
    chart: {
      type: 'column',
      marginLeft: 400
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    legend: {
      align: 'left',
      floating: true,
      verticalAlign: 'top',
      layout: 'vertical',
      itemMarginBottom: 13,
      x: 0,
      itemStyle: {
        fontSize: '14px',
        fontFamily: 'Helvetica',
        lineHeight: '20px'
      }
    },
    xAxis: {
      categories: [
        '2019',
        '2020',
        '2021',
      ],
      crosshair: true
    },
    yAxis: [{ // Primary yAxis
      labels: {
          format: '{value}',
          style: {
              color: '#666'
          }
      },
      labels: {
        format: '{value:,.0f} Mio. EUR',
          style: {
              color: "#666"
          }

      },
      title: {
          text: '',
          style: {
              color: '#666'
          }
      }
  }, { // Secondary yAxis
      title: {
          text: '',
          style: {
              color: '#666'
          }
      },
      labels: {
          format: '{value:,.0f} Mio. EUR',
          style: {
              color: "#666"
          }
      },
      opposite: true
  }],
      credits: {
          enabled: false
      },
    tooltip: {
      borderColor: '#0066CC',
      backgroundColor: '#0066CC',
      borderWidth: 5,
      headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
      pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
        '<span style="font-size:14px; padding:0"><b>{point.y} Mio. EUR</b></span></li>',
      footerFormat: '</ul>',
      shared: true,
      useHTML: true,
      style: {
        color: '#fff'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Umsatzerlöse',
      color: '#0066CC',
      data: [18997, 19566 , 20618],
      type: 'column',
      yAxis: 0,

    }, {
      name: 'Humanpharma',
      color: '#003366',
      data: [13961 ,14415, 15294],
      type: 'column',
      yAxis: 0

    }, {
      name: 'Tiergesundheit',
      color: '#99cccc',
      data: [4035 ,4121,4295],
      type: 'column',
      yAxis: 0

    }, {
      name: 'Biopharmazeutische <br>Auftragsproduktion',
      color: '#669999',
      data: [786 ,837,917],
      type: 'column',
      yAxis: 0
      }, {
      name: 'Sonstige Umsatzerlöse',
      color: '#cccc00',
      data: [41, 33, 33],
      type: 'column',
      yAxis: 0

        }, {
      name: 'Aufgegebene <br>Geschäftsbereiche',
      color: '#CC9966',
      data: [79, 160, 174],
      data: [174, 160, 79],
      type: 'column',
      yAxis: 0

        }


    ]
});

}




var chart_de_2 = document.querySelector('.chart-de-2');
if (chart_de_2) {

  Highcharts.setOptions({
    lang: {
      decimalPoint: ',',
      thousandsSep: '.'
    }
  });

  Highcharts.chart('chart-de-2', {
    chart: {
      type: 'column',
      marginLeft: 400
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    legend: {
      align: 'left',
      floating: true,
      verticalAlign: 'top',
      layout: 'vertical',
      itemMarginBottom: 13,
      x: 0,
      itemStyle: {
        fontSize: '14px',
        fontFamily: 'Helvetica',
        lineHeight: '20px'
      }
    },
    xAxis: {
      categories: [
        '2019',
        '2020',
        '2021',
      ],
      crosshair: true
    },
    yAxis: [{ // Primary yAxis
      labels: {
          format: '{value}',

          style: {
              color: Highcharts.getOptions().colors[1]
          }
      },
      labels: {
        format: '{value:,.0f} in Mio. €',
      },
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[1]
          }
      }
  }, { // Secondary yAxis
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[0]
          }
      },
      labels: {
          format: '{value:,.0f} in %',
          style: {
              color: "#666"
          }
      },
      opposite: true
  }],
      credits: {
          enabled: false
      },
    tooltip: {
      borderColor: '#0066CC',
      backgroundColor: '#0066CC',
      borderWidth: 5,
      headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
      pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
        '<span style="font-size:14px; padding:0"><b>{point.y} in Mio. €</b></span></li>',
      footerFormat: '</ul>',
      shared: true,
      useHTML: true,
      style: {
        color: '#fff'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Betriebsergebnis',
      color: '#0066CC',
      data: [3782, 4624 , 4705],
      type: 'column',
      yAxis: 0,

    }


    ]
});

}



var chart_de_3 = document.querySelector('.chart-de-3');
if (chart_de_3) {

  Highcharts.setOptions({
    lang: {
      decimalPoint: ',',
      thousandsSep: '.'
    }
  });

  Highcharts.chart('chart-de-3', {
    chart: {
      type: 'column',
      marginLeft: 400
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    legend: {
      align: 'left',
      floating: true,
      verticalAlign: 'top',
      layout: 'vertical',
      itemMarginBottom: 13,
      x: 0,
      itemStyle: {
        fontSize: '14px',
        fontFamily: 'Helvetica',
        lineHeight: '20px'
      }
    },
    xAxis: {
      categories: [
        '2019',
        '2020',
        '2021',
      ],
      crosshair: true
    },
    yAxis: [{ // Primary yAxis
      labels: {
          format: '{value}',

          style: {
              color: Highcharts.getOptions().colors[1]
          }
      },
      labels: {
        format: '{value:,.0f} in Mio. €',
      },
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[1]
          }
      }
  }, { // Secondary yAxis
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[0]
          }
      },
      labels: {
          format: '{value:,.0f}  / in %',
          style: {
              color: "#666"
          }
      },
      opposite: true
  }],
      credits: {
          enabled: false
      },
    tooltip: {
      borderColor: '#0066CC',
      backgroundColor: '#0066CC',
      borderWidth: 5,
      headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
      pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
        '<span style="font-size:14px; padding:0"><b>{point.y} in Mio. EUR</b></span></li>',
      footerFormat: '</ul>',
      shared: true,
      useHTML: true,
      style: {
        color: '#fff'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Forschungs- und<br>Entwicklungsaufwendungen',
      color: '#003366',
      data: [3462, 3696, 4127],
      type: 'column',
      yAxis: 0,

    }


    ]
});

}




var chart_de_4 = document.querySelector('.chart-de-4');
if (chart_de_4) {

  Highcharts.setOptions({
    lang: {
      decimalPoint: ',',
      thousandsSep: '.'
    }
  });

  Highcharts.chart('chart-de-4', {
    chart: {
      type: 'column',
      marginLeft: 400
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    legend: {
      align: 'left',
      floating: true,
      verticalAlign: 'top',
      layout: 'vertical',
      itemMarginBottom: 13,
      x: 0,
      itemStyle: {
        fontSize: '14px',
        fontFamily: 'Helvetica',
        lineHeight: '20px'
      }
    },
    xAxis: {
      categories: [
        '2019',
        '2020',
        '2021',
      ],
      crosshair: true
    },
    yAxis: [{ // Primary yAxis
      labels: {
          format: '{value}',

          style: {
              color: Highcharts.getOptions().colors[1]
          }
      },
      labels: {
        format: '{value:,.0f} / in Mio. €',
      },
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[1]
          }
      }
  }, { // Secondary yAxis
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[0]
          }
      },
      labels: {
          format: '{value:,.0f}  / in %',
          style: {
              color: "#666"
          }
      },
      opposite: true
  }],
      credits: {
          enabled: false
      },
    tooltip: {
      borderColor: '#0066CC',
      backgroundColor: '#0066CC',
      borderWidth: 5,
      headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
      pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
        '<span style="font-size:14px; padding:0"><b>{point.y} in Mio. €</b></span></li>',
      footerFormat: '</ul>',
      shared: true,
      useHTML: true,
      style: {
        color: '#fff'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Investitionen in Sachanlagen',
      color: '#99cccc',
      data: [1073, 1046, 968],
      type: 'column',
      yAxis: 0,

    }


    ]
});

}


// EN


var chart_en = document.querySelector('.chart-en');
if (chart_en) {

  Highcharts.setOptions({
    lang: {
      decimalPoint: '.',
      thousandsSep: ','
    }
  });



  Highcharts.chart('chart1-en', {
    chart: {
      type: 'column',
      marginLeft: 400
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    legend: {
      align: 'left',
      floating: true,
      verticalAlign: 'top',
      layout: 'vertical',
      itemMarginBottom: 13,
      x: 0,
      itemStyle: {
        fontSize: '14px',
        fontFamily: 'Helvetica',
        lineHeight: '20px'
      }
    },
    xAxis: {
      categories: [
        '2019',
        '2020',
        '2021',
      ],
      crosshair: true
    },
    yAxis: [{ // Primary yAxis
      labels: {
          format: '{value}',
          style: {
              color: '#666'
          }
      },
      labels: {
        format: '{value:,.0f}  million EUR',
          style: {
              color: "#666"
          }

      },
      title: {
          text: '',
          style: {
              color: '#666'
          }
      }
  }, { // Secondary yAxis
      title: {
          text: '',
          style: {
              color: '#666'
          }
      },
      labels: {
          format: '{value:,.0f}  / million EUR',
          style: {
              color: "#666"
          }
      },
      opposite: true
  }],
      credits: {
          enabled: false
      },
    tooltip: {
      borderColor: '#0066CC',
      backgroundColor: '#0066CC',
      borderWidth: 5,
      headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
      pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
        '<span style="font-size:14px; padding:0"><b>{point.y} million EUR</b></span></li>',
      footerFormat: '</ul>',
      shared: true,
      useHTML: true,
      style: {
        color: '#fff'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Net sales',
      color: '#0066CC',
      data: [18997, 19566 , 20618],
      type: 'column',
      yAxis: 0,

    }, {
      name: 'Human Pharma',
      color: '#003366',
      data: [13961 ,14415,15294],
      type: 'column',
      yAxis: 0

    }, {
      name: 'Animal Health',
      color: '#99cccc',
      data: [4035 ,4121,4295],
      type: 'column',
      yAxis: 0

    }, {
      name: 'Biopharmaceutical <br>Contract Manufacturing',
      color: '#669999',
      data: [786 ,837,917],
      type: 'column',
      yAxis: 0
      }, {
      name: 'Other sales',
      color: '#cccc00',
      data: [41, 33, 33],
      type: 'column',
      yAxis: 0

        }, {
      name: 'Discontinued operations',
      color: '#CC9966',
      data: [174, 160, 79],
      type: 'column',
      yAxis: 0

        }


    ]
});

}





var chart_en_2 = document.querySelector('.chart2-en');
if (chart_en_2) {

  Highcharts.setOptions({
    lang: {
      decimalPoint: '.',
      thousandsSep: ','
    }
  });

  Highcharts.chart('chart2-en', {
    chart: {
      type: 'column',
      marginLeft: 400
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    legend: {
      align: 'left',
      floating: true,
      verticalAlign: 'top',
      layout: 'vertical',
      itemMarginBottom: 13,
      x: 0,
      itemStyle: {
        fontSize: '14px',
        fontFamily: 'Helvetica',
        lineHeight: '20px'
      }
    },
    xAxis: {
      categories: [
        '2019',
        '2020',
        '2021',
      ],
      crosshair: true
    },
    yAxis: [{ // Primary yAxis
      labels: {
          format: '{value}',

          style: {
              color: Highcharts.getOptions().colors[1]
          }
      },
      labels: {
        format: '{value:,.0f}  million EUR',
      },
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[1]
          }
      }
  }, { // Secondary yAxis
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[0]
          }
      },
      labels: {
          format: '{value:,.0f}  / in %',
          style: {
              color: "#666"
          }
      },
      opposite: true
  }],
      credits: {
          enabled: false
      },
    tooltip: {
      borderColor: '#0066CC',
      backgroundColor: '#0066CC',
      borderWidth: 5,
      headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
      pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
        '<span style="font-size:14px; padding:0"><b>{point.y} million EUR</b></span></li>',
      footerFormat: '</ul>',
      shared: true,
      useHTML: true,
      style: {
        color: '#fff'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Operating income',
      color: '#0066CC',
      data: [3782, 4624 , 4705],
      type: 'column',
      yAxis: 0,

    }


    ]
});

}





var chart_en_3 = document.querySelector('.chart-en-3');
if (chart_en_3) {

  Highcharts.setOptions({
    lang: {
      decimalPoint: '.',
      thousandsSep: ','
    }
  });

  Highcharts.chart('chart-en-3', {
    chart: {
      type: 'column',
      marginLeft: 400
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    legend: {
      align: 'left',
      floating: true,
      verticalAlign: 'top',
      layout: 'vertical',
      itemMarginBottom: 13,
      x: 0,
      itemStyle: {
        fontSize: '14px',
        fontFamily: 'Helvetica',
        lineHeight: '20px'
      }
    },
    xAxis: {
      categories: [
        '2019',
        '2020',
        '2021',
      ],
      crosshair: true
    },
    yAxis: [{ // Primary yAxis
      labels: {
          format: '{value}',

          style: {
              color: Highcharts.getOptions().colors[1]
          }
      },
      labels: {
        format: '{value:,.0f} million EUR',
      },
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[1]
          }
      }
  }, { // Secondary yAxis
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[0]
          }
      },
      labels: {
          format: '{value:,.0f}  / in %',
          style: {
              color: "#666"
          }
      },
      opposite: true
  }],
      credits: {
          enabled: false
      },
    tooltip: {
      borderColor: '#0066CC',
      backgroundColor: '#0066CC',
      borderWidth: 5,
      headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
      pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
        '<span style="font-size:14px; padding:0"><b>{point.y} million EUR</b></span></li>',
      footerFormat: '</ul>',
      shared: true,
      useHTML: true,
      style: {
        color: '#fff'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Investments into R&D',
      color: '#003366',
      data: [3462, 3696, 4127],
      type: 'column',
      yAxis: 0,

    }


    ]
});

}


var chart_en_4 = document.querySelector('.chart-en-4');
if (chart_en_4) {

  Highcharts.setOptions({
    lang: {
      decimalPoint: '.',
      thousandsSep: ','
    }
  });

  Highcharts.chart('chart-en-4', {
    chart: {
      type: 'column',
      marginLeft: 400
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    legend: {
      align: 'left',
      floating: true,
      verticalAlign: 'top',
      layout: 'vertical',
      itemMarginBottom: 13,
      x: 0,
      itemStyle: {
        fontSize: '14px',
        fontFamily: 'Helvetica',
        lineHeight: '20px'
      }
    },
    xAxis: {
      categories: [
        '2019',
        '2020',
        '2021',
      ],
      crosshair: true
    },
    yAxis: [{ // Primary yAxis
      labels: {
          format: '{value}',

          style: {
              color: Highcharts.getOptions().colors[1]
          }
      },
      labels: {
        format: '{value:,.0f} / in € million',
      },
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[1]
          }
      }
  }, { // Secondary yAxis
      title: {
          text: '',
          style: {
              color: Highcharts.getOptions().colors[0]
          }
      },
      labels: {
          format: '{value:,.0f}  / in %',
          style: {
              color: "#666"
          }
      },
      opposite: true
  }],
      credits: {
          enabled: false
      },
    tooltip: {
      borderColor: '#0066CC',
      backgroundColor: '#0066CC',
      borderWidth: 5,
      headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
      pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
        '<span style="font-size:14px; padding:0"><b>{point.y} million EUR</b></span></li>',
      footerFormat: '</ul>',
      shared: true,
      useHTML: true,
      style: {
        color: '#fff'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Investments in tangible assets',
      color: '#99cccc',
      data: [1073, 1046, 968],
      type: 'column',
      yAxis: 0,

    }


    ]
});

}


  //  Highcharts.chart('chart2-de', {
  //     chart: {
  //       type: 'column',
  //       marginLeft: 400
  //     },
  //     title: {
  //       text: ''
  //     },
  //     subtitle: {
  //       text: ''
  //     },
  //     legend: {
  //       align: 'left',
  //       floating: true,
  //       verticalAlign: 'top',
  //       layout: 'vertical',
  //       itemMarginBottom: 13,
  //       x: 0,
  //       itemStyle: {
  //         fontSize: '14px',
  //         fontFamily: 'Helvetica',
  //         lineHeight: '20px'
  //       }
  //     },
  //     xAxis: {
  //       categories: [
  //         '2021',
  //         '2020',
  //         '2019',
  //         '2018',
  //         '2017',
  //       ],
  //       crosshair: true
  //     },
  //     yAxis: {
  //       title: {
  //         text: ''
  //       },
  //       labels: {
  //         format: '{value:,.0f} / in € million',
  //       },

  //     },
  //       credits: {
  //           enabled: false
  //       },
  //     tooltip: {
  //       borderColor: '#0066CC',
  //       backgroundColor: '#0066CC',
  //       borderWidth: 5,
  //       headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
  //       pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
  //         '<span style="font-size:14px; padding:0"><b>{point.y} € million</b></span></li>',
  //       footerFormat: '</ul>',
  //       shared: true,
  //       useHTML: true,
  //       style: {
  //         color: '#fff'
  //       }
  //     },
  //     plotOptions: {
  //       column: {
  //         pointPadding: 0.2,
  //         borderWidth: 0
  //       }
  //     },
  //     series: [{
  //       name: 'Eigenkapital',
  //       color: '#0066CC',
  //       data: [1717.1, 1464.1, 1417.3, 1395.5, 1293.8]

  //     }, {
  //       name: 'Sachinvestitionen',
  //       color: '#F9E160',
  //       data: [194.0, 187.2, 183.3, 160.3, 130.7]

  //     }, {
  //       name: 'Bilanzsumme',
  //       color: '#666',
  //       data: [4246.1, 3722.5, 3531.9, 3449.7, 3232.8]

  //     },{
  //       name: 'Free Cashflow',
  //       color: '#DED9C8',
  //       data: [381.5, 308.1, -138.2, -83.9, 209.6],
  //     },

  //     ]
  //   });



  //  Highcharts.chart('chart3-de', {
  //     chart: {
  //       type: 'column',
  //       marginLeft: 400
  //     },
  //     title: {
  //       text: ''
  //     },
  //     subtitle: {
  //       text: ''
  //     },
  //     legend: {
  //       align: 'left',
  //       floating: true,
  //       verticalAlign: 'top',
  //       layout: 'vertical',
  //       itemMarginBottom: 13,
  //       x: 0,
  //       itemStyle: {
  //         fontSize: '14px',
  //         fontFamily: 'Helvetica',
  //         lineHeight: '20px'
  //       }
  //     },
  //     xAxis: {
  //       categories: [
  //         '2021',
  //         '2020',
  //         '2019',
  //         '2018',
  //         '2017',
  //       ],
  //       crosshair: true
  //     },
  //     yAxis: {
  //       title: {
  //         text: ''
  //       },
  //       labels: {
  //         format: '{value:,.0f}'
  //       }
  //     },
  //       credits: {
  //           enabled: false
  //       },
  //     tooltip: {
  //       borderColor: '#0066CC',
  //       backgroundColor: '#0066CC',
  //       borderWidth: 5,
  //       headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
  //       pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
  //         '<span style="font-size:14px; padding:0"><b>{point.y:,.0f}</b></span></li>',
  //       footerFormat: '</ul>',
  //       shared: true,
  //       useHTML: true,
  //       style: {
  //         color: '#fff'
  //       }
  //     },
  //     plotOptions: {
  //       column: {
  //         pointPadding: 0.2,
  //         borderWidth: 0
  //       }
  //     },
  //     series: [{
  //       name: 'Anzahl Mitarbeitende am Bilanzstichtag',
  //       color: '#0066CC',
  //       data: [11957, 11395, 11448, 11132, 10961]

  //     }
  //     ]
  //   });

  // }


  // ENGLISCH

  // var $chart_en = $('.chart-en');

  // if ($chart_en.length) {


  //   Highcharts.setOptions({
  //     lang: {
  //       decimalPoint: '.',
  //       thousandsSep: ','
  //     }
  //   });

  //   Highcharts.chart('chart1-en', {
  //     chart: {
  //       type: 'column',
  //       marginLeft: 400
  //     },
  //     title: {
  //       text: ''
  //     },
  //     subtitle: {
  //       text: ''
  //     },
  //     legend: {
  //       align: 'left',
  //       floating: true,
  //       verticalAlign: 'top',
  //       layout: 'vertical',
  //       itemMarginBottom: 13,
  //       x: 0,
  //       itemStyle: {
  //         fontSize: '14px',
  //         fontFamily: 'Helvetica',
  //         lineHeight: '20px'
  //       }
  //     },
  //     xAxis: {
  //       categories: [
  //         '2021',
  //         '2020',
  //         '2019',
  //         '2018',
  //         '2017',
  //       ],
  //       crosshair: true
  //     },
  //     yAxis: [{ // Primary yAxis
  //       labels: {
  //           format: '{value}',

  //           style: {
  //               color: Highcharts.getOptions().colors[1]
  //           }
  //       },
  //       labels: {
  //         format: '{value:,.0f} / in € million',
  //       },
  //       title: {
  //           text: '',
  //           style: {
  //               color: Highcharts.getOptions().colors[1]
  //           }
  //       }
  //   }, { // Secondary yAxis
  //       title: {
  //           text: '',
  //           style: {
  //               color: Highcharts.getOptions().colors[0]
  //           }
  //       },
  //       labels: {
  //           format: '{value:,.0f} / in € million',
  //           style: {
  //               color: "#666"
  //           }
  //       },
  //       opposite: true
  //   }],
  //       credits: {
  //           enabled: false
  //       },
  //     tooltip: {
  //       borderColor: '#0066CC',
  //       backgroundColor: '#0066CC',
  //       borderWidth: 5,
  //       headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
  //       pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
  //         '<span style="font-size:14px; padding:0"><b>€ {point.y} million</b></span></li>',
  //       footerFormat: '</ul>',
  //       shared: true,
  //       useHTML: true,
  //       style: {
  //         color: '#fff'
  //       }
  //     },
  //     plotOptions: {
  //       column: {
  //         pointPadding: 0.2,
  //         borderWidth: 0
  //       }
  //     },
  //     series: [{
  //       name: 'Net sales',
  //       color: '#0066CC',
  //       data: [4797.8, 4042.3 ,3898.0, 3889.2, 3761.0],
  //       type: 'column',
  //       yAxis: 0,

  //     }, {
  //       name: 'Research and development costs',
  //       color: '#F9E160',
  //       data: [262.3, 237.4 ,243.6, 233.4, 217.6],
  //       type: 'column',
  //       yAxis: 1

  //     }, {
  //       name: 'EBITDA',
  //       color: '#666',
  //       data: [532.1, 333.4, 280.3, 372.7, 335.7],
  //       type: 'spline',
  //       yAxis: 1

  //     }, {
  //       name: 'EBIT',
  //       color: '#EFBF9B',
  //       data: [384.9, 185.6, 164.0, 256.8, 215.2],
  //       type: 'spline',
  //       yAxis: 1
  //       }, {
  //       name: 'Income before taxes',
  //       color: '#D4E1ED',
  //       data: [357.1, 158.1, 135.7, 225.7, 184.5],
  //       type: 'spline',
  //       yAxis: 1

  //         }, {
  //       name: 'Net income',
  //       color: '#B2B1A9',
  //       data: [272.6, 107.1, 96.3, 152.0, 115.4],
  //       type: 'spline',
  //       yAxis: 1

  //         },  {
  //       name: 'Personnel expenses',
  //       color: '#F9E160',
  //       data: [819.8, 742.2, 730.3, 693.0, 673.5],
  //       type: 'spline',
  //       yAxis: 1
  //     },


  //     ]
  //   });


   // Highcharts.chart('chart2-en', {
   //    chart: {
   //      type: 'column',
   //      marginLeft: 400
   //    },
   //    title: {
   //      text: ''
   //    },
   //    subtitle: {
   //      text: ''
   //    },
   //    legend: {
   //      align: 'left',
   //      floating: true,
   //      verticalAlign: 'top',
   //      layout: 'vertical',
   //      itemMarginBottom: 13,
   //      x: 0,
   //      itemStyle: {
   //        fontSize: '14px',
   //        fontFamily: 'Helvetica',
   //        lineHeight: '20px'
   //      }
   //    },
   //    xAxis: {
   //      categories: [
   //        '2021',
   //        '2020',
   //        '2019',
   //        '2018',
   //        '2017',
   //      ],
   //      crosshair: true
   //    },
   //    yAxis: {
   //      title: {
   //        text: ''
   //      },
   //      labels: {
   //        format: '{value:,.0f} / in € million',
   //      },

   //    },
   //      credits: {
   //          enabled: false
   //      },
   //    tooltip: {
   //      borderColor: '#0066CC',
   //      backgroundColor: '#0066CC',
   //      borderWidth: 5,
   //      headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
   //      pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
   //        '<span style="font-size:14px; padding:0"><b>€ {point.y} million</b></span></li>',
   //      footerFormat: '</ul>',
   //      shared: true,
   //      useHTML: true,
   //      style: {
   //        color: '#fff'
   //      }
   //    },
   //    plotOptions: {
   //      column: {
   //        pointPadding: 0.2,
   //        borderWidth: 0
   //      }
   //    },
   //    series: [{
   //      name: 'Equity',
   //      color: '#0066CC',
   //      data: [1717.1, 1464.1, 1417.3, 1395.5, 1293.8]

   //    }, {
   //      name: 'Capital expenditure',
   //      color: '#F9E160',
   //      data: [194.0, 187.2, 183.3, 160.3, 130.7]

   //    }, {
   //      name: 'Total assets',
   //      color: '#666',
   //      data: [4246.1, 3722.5, 3531.9, 3449.7, 3232.8]

   //    }, {
   //      name: 'Free cash flow',
   //      color: '#DED9C8',
   //      data: [381.5, 308.1, -138.2, -83.9, 209.6],
   //  }

   //    ]
   //  });



//    Highcharts.chart('chart3-en', {
//       chart: {
//         type: 'column',
//         marginLeft: 400
//       },
//       title: {
//         text: ''
//       },
//       subtitle: {
//         text: ''
//       },
//       legend: {
//         align: 'left',
//         floating: true,
//         verticalAlign: 'top',
//         layout: 'vertical',
//         itemMarginBottom: 13,
//         x: 0,
//         itemStyle: {
//           fontSize: '14px',
//           fontFamily: 'Helvetica',
//           lineHeight: '20px'
//         }
//       },
//       xAxis: {
//         categories: [
//           '2021',
//           '2020',
//           '2019',
//           '2018',
//           '2017',
//         ],
//         crosshair: true
//       },
//       yAxis: {
//         title: {
//           text: ''
//         },
//         labels: {
//           format: '{value:,.0f}'
//         }
//       },
//         credits: {
//             enabled: false
//         },
//       tooltip: {
//         borderColor: '#0066CC',
//         backgroundColor: '#0066CC',
//         borderWidth: 5,
//         headerFormat: '<span style="font-size:10px"></span><ul style="list-style: none;">',
//         pointFormat: '<li class="accordion__tooltip"><span style="font-size:14px; padding:0">{series.name}: </span>' +
//           '<span style="font-size:14px; padding:0"><b>{point.y:,.0f}</b></span></li>',
//         footerFormat: '</ul>',
//         shared: true,
//         useHTML: true,
//         style: {
//           color: '#fff'
//         }
//       },
//       plotOptions: {
//         column: {
//           pointPadding: 0.2,
//           borderWidth: 0
//         }
//       },
//       series: [{
//         name: 'Number of employees',
//         color: '#0066CC',
//         data: [11957, 11395, 11448, 11132, 10961]

//       }
//       ]
//     });


//   }

// });


